import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para quien recién está entrando al mundo de las inversiones.'
}, {
  q: '¿Esto son señales de compra/venta?',
  a: 'No. El Discord comparte análisis y actualizaciones — el objetivo es que aprendas a decidir vos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato tras la compra.'
}, {
  q: '¿Cuánto tiempo tengo acceso al Discord?',
  a: '1 año de acceso desde el momento de la compra.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-ink-950" data-id="element-62" data-mp="1z5jh4q7ys2di">
      <Reveal data-id="element-63" data-mp="snd5tx043woe">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-64" data-mp="snween3vh8pr">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <div className="mt-8 space-y-3" data-id="element-65" data-mp="pho9rrzzbmm3">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <Reveal key={f.q} delay={i * 0.05} data-id="element-66" data-mp="ugirsrq4h755" data-mpi={i}>
              <div className="overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-67" data-mp="fk0e8zujub2v">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-ink-850" data-id="element-68" data-mp="kiuubu14tlja">
                  <span className="font-display text-sm font-semibold text-white sm:text-base" data-id="element-69" data-mp="3sywpo6b5cce6">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-70" data-mp="1t4zj6xdczrd" />
                </button>
                <AnimatePresence initial={false} data-id="element-71" data-mp="1ugulht0pw5oz">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} data-id="element-72" data-mp="1uixmt97bll90">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-gray-400" data-id="element-73" data-mp="1fq3tokz4l6lv">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}